import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/EmitirCertificado.css';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import CardNotification from '../components/CardNotification';
import { FaSearch } from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import { FiRefreshCw } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { FaPlus } from "react-icons/fa";
import Cookies from 'js-cookie';


const EmitirCertificado = () => {
    const [certificados, setCertificados] = useState([]);
    const [filtroStatus, setFiltroStatus] = useState('todos');
    const [certificadosSelecionados, setCertificadosSelecionados] = useState([]);
    const [notification, setNotification] = useState({ message: '', type: '', show: false });
    const [searchTerm, setSearchTerm] = useState('');
    let id_instituicao = localStorage.getItem('id_instituicao');
    

    useEffect(() => {
        fetchCertificados(); 
    
        const interval = setInterval(() => {
            fetchCertificados();
        }, 10000);
    
        return () => clearInterval(interval); 
    }, []);

    const fetchCertificados = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/certificado/instituicao/${id_instituicao}`, {
                withCredentials: true,
            });
    
            const certificadosFiltrados = response.data.filter(cert => cert.disciplinas !== null);
            setCertificados(certificadosFiltrados);
        } catch (error) {
            setNotification({ message: 'Erro ao carregar a lista de certificados.', type: 'error', show: true });
        }
    };
    
    

    const toggleSelecionarCertificado = (id, emitido) => {
        if (emitido) return; 
        setCertificadosSelecionados((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const emitirCertificadosSelecionados = async () => {
        if (certificadosSelecionados.length === 0) {
            setNotification({ message: 'Selecione pelo menos um certificado para emitir.', type: 'warning', show: true });
            setTimeout(() => {
                setNotification({ show: false });
            }, 5000);
            return;
        }
    
        try {
            await Promise.all(certificadosSelecionados.map(id => 
                axios.post(`${process.env.REACT_APP_API_URL}/certificados/${id}/gerar`,{},
                    {
                        withCredentials: true,
                    }
                )
            ));
    
            setNotification({ message: 'Certificados gerados com sucesso!', type: 'success', show: true });
            setTimeout(() => {
                setNotification({ show: false });
            }, 5000);
            fetchCertificados();
            setCertificadosSelecionados([]);
        } catch (error) {
            setNotification({ message: 'Erro ao gerar certificados.', type: 'error', show: true });
        }
    };

    const baixarCertificado = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/certificados/${id}/download`, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `certificado_${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            setNotification({ message: 'Erro ao baixar certificado.', type: 'error', show: true });
        }
    };

    const atualizarModeloCertificado = async (id) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/certificados/${id}/atualizar-modelo`,{},
                {
                withCredentials: true
            });
            setNotification({ message: 'Modelo atualizado com sucesso!', type: 'success', show: true });
            setTimeout(() => {
                setNotification({ show: false });
            }, 5000);
            fetchCertificados();
        } catch (error) {
            setNotification({ message: 'Erro ao atualizar o modelo.', type: 'error', show: true });
            setTimeout(() => {
                setNotification({ show: false });
            }, 5000);
        }
    };

    const closeNotification = () => {
        setNotification({ ...notification, show: false });
    };

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="emitir-certificado-container">
                <h1>Emitir Certificados</h1>

                {notification.show && (
                    <CardNotification message={notification.message} type={notification.type} onClose={closeNotification} />
                )}

                <div className="filtro-e-pesquisa">
                    <div className="filtro-container">
                        <label>Filtrar:</label>
                        <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
                            <option value="todos">Todos</option>
                            <option value="emitidos">Já Emitidos</option>
                            <option value="nao-emitidos">Não Emitidos</option>
                        </select>
                    </div>

                    <div className="pesquisa-container">
                        <FaSearch className="lupa-icon" />
                        <input
                            type="text"
                            placeholder="Pesquisar por nome..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />  
                    </div>

                    <div className="emitir-btn-container">
                        <Link to="/cadastrar-certificado">
                            <button
                                className='emitir-btn1'> 
                                <FaPlus className='plus-logo'/>
                                Cadastrar Certificados
                            </button>
                        </Link>
                    </div>
                    <div className="emitir-btn-container">
                        <button
                            className={`emitir-btn ${certificadosSelecionados.length > 0 ? 'enabled' : 'disabled'}`}
                            onClick={emitirCertificadosSelecionados}
                            disabled={certificadosSelecionados.length === 0}
                        >
                            Emitir Selecionados
                        </button>
                    </div>
                </div>

                <table className="certificados-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nome</th>
                            <th>CPF</th>
                            <th>Curso</th>
                            <th>Professor</th>
                            <th>Status</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {certificados
                            .filter((cert) =>
                                filtroStatus === 'todos'
                                    ? true
                                    : filtroStatus === 'emitidos'
                                    ? cert.arquivo_certificado !== null
                                    : cert.arquivo_certificado === null
                            )
                            .filter((cert) =>
                                cert.nome.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .sort((a, b) => {
                                if (a.arquivo_certificado === null && b.arquivo_certificado !== null) return -1;
                                if (a.arquivo_certificado !== null && b.arquivo_certificado === null) return 1;
                                return a.nome.localeCompare(b.nome); 
                            })
                            .map((cert) => (
                                <tr
                                    key={cert.id_certificado}
                                    className={certificadosSelecionados.includes(cert.id_certificado) ? 'selected' : ''}
                                    onClick={() => toggleSelecionarCertificado(cert.id_certificado, cert.arquivo_certificado !== null)}
                                    style={{ cursor: cert.arquivo_certificado !== null ? 'not-allowed' : 'pointer' }}
                                >
                                    <td>
                                        {cert.arquivo_certificado === null && (
                                            <input
                                                type="checkbox"
                                                checked={certificadosSelecionados.includes(cert.id_certificado)}
                                                onChange={(e) => e.stopPropagation()}
                                            />
                                        )}
                                    </td>
                                    <td>{cert.nome}</td>
                                    <td>{cert.cpf}</td>
                                    <td>{cert.curso}</td>
                                    <td>{cert.professor}</td>
                                    <td>{cert.arquivo_certificado !== null ? 'Emitido' : 'Não Emitido'}</td>
                                    <td>
                                        {cert.arquivo_certificado !== null ? (
                                            <div className="acoes-btns">
                                                <button
                                                    className="baixar-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        baixarCertificado(cert.id_certificado);
                                                    }}
                                                >
                                                    <FaDownload /> Baixar
                                                </button>
                                                <button
                                                    className="atualizar-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        atualizarModeloCertificado(cert.id_certificado);
                                                    }}
                                                >
                                                    <FiRefreshCw /> Atualizar Modelo
                                                </button>
                                            </div>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmitirCertificado;

